(function() {
  angular.module("irricrops")
    .factory("MultiChart", ['Config', '$timeout', 'urls', '$rootScope', "global", function(Config, $timeout, urls, $rootScope, global){

      var ejeSample = {
                    gridLineWidth: 1,
                    //gridLineColor: colors.riegoReal.background,
                    title: {
                        text: 'Milimetros de Riego',
                        style: {
                            //color: colors.riegoReal.background
                        }
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            //color: colors.riegoReal.background
                        }
                    }

                };
      var serieErrorSample = {
                  name          : '',
                  type          : 'errorbar',
                  data          : [],
                  lineWidth     : 3,
                  stemWidth     : 4,
                  //stemDashStyle : "dot",
                  whiskerLength : 15,
                  whiskerWidth  : 3,
                  tooltip       : {},
                };

      var serieSample = {
                    animation: false,
                    boostThreshold: 0,
                    name: '',
                    type: 'spline',
                    lineWidth: 0 ,
                    yAxis: 2,
                    //color: colors.scholander.background,
                    data: [],
                    turboThreshold: 100,
                    label:{
                      enabled: false
                    },
                    tooltip: {
                        //valueSuffix: ' bares',
                        //valuePreffix: '-'
                    },
                    marker:{
                    //   symbol: "circle"
                  },
                  events:{}

                };

      var serieSampleComentario={
           type: 'flags',
           name: 'Comentarios',
           color: '#1b5e20',
           shape: 'circlepin',
           y: 5,
           showInLegend:true,
           data:[]
      };
      var plotBandX = {
                        from: 0,
                        to: 1,
                        color:'#EFFFFF',
                        borderColor: "#000000",
                        borderWidth: 1,
                        label: {
                            text: '',
                            textAlign: "left",
                            style: {
                                color: '#999999'
                            },
                            y: 30
                        }
                    };
      var plotBandY = {
                      from: 0,
                      to: 10, //limite de la scholander
                      color: '#FFD2C6',
                      label: {
                          style: {
                            color: '#555555'
                          },
                        verticalAlign: 'top',
                        y: 20
                      }
                    };

      var plotLineY = {
                      value: 10,
                      color: '#FFD2C6',
                      label: {
                        style: {
                          color: '#555555'
                        },
                        verticalAlign: 'top',
                        align:'left'
                      }
                    };

/**
 * indice de ejes
 *  0 - temperatura
 *  1 - bares (negativos)
 *  2 - mm de agua
 *  3 - humedad %
 *  4 - porcentaje -100 a 50
 *  5 - kg
 *  6 - Toneladas /ha
 *  7 - metros cubicos
 *  8 - Peso poda (kg)
 *  9 - bayas (cantidad)
 * 10 - Produccion (ton/ha)
 * 11 - ravaz (indice)
 * 12 - porcentaje 100
 *  */



    var clickX, clickY;

      var startDragging = function (line, label, e) {

        var mchart = line.axis.chart.userOptions.getMChart();
        var chart = line.axis.chart;
        mchart.setTooltipEnabled(chart, false);

        var le = $(label.element);

        le.addClass("dragging");

        if(le.find(".num").length == 0){
          le.append($("<span class='num'></span>"));
        }

        $(document).bind({
          'touchmove.line': function(e){
            var pageX = e.originalEvent.touches[0].pageX;
            var pageY = e.originalEvent.touches[0].pageY;
            stepMobile(line, label, e);
          },
          'mousemove.line': function(e){
            step(line, label, e);
          },
          'touchend.line':function(e){
            stopMobile(line, label, e);
          },
          'mouseup.line':function(e){
            stop(line, label, e);
          }
        });
        if(e.pageY !== undefined){
          //clickX = e.pageX - line.translateX;
          clickY = e.pageY - line.svgElem.translateY; //uncomment if plotline should be also moved vertically
        }else{
          var pageX = e.touches[0].pageX;
          var pageY = e.touches[0].pageY;
          //$("#text2").html(" px"+pageX+" py"+pageY);
          //clickX = e.pageX - line.translateX;
          clickY = pageY - line.svgElem.translateY; //uncomment if plotline should be also moved vertically
        }

      }

      var step = function (line, label, e) {
        //$("#text").html("mouseover "+e.pageX+" - "+clickX +" - "+ e.pageY+" - "+clickY);
        var min_pixels  = line.axis.toPixels(line.axis.min);
        var max_pixels  = line.axis.toPixels(line.axis.max);
        var actual_pos  = line.axis.toPixels(line.options.value) + (e.pageY - clickY);
        if(min_pixels > actual_pos && // min y max de eje Y
            max_pixels < actual_pos ){

          line.svgElem.translate(e.pageX - clickX, e.pageY - clickY);
          var diffPixels = e.pageY - clickY;
          var pixels     = line.axis.toPixels(line.options.value);
          var newValue   = line.axis.toValue(pixels + diffPixels);
          newValue       = _.round(newValue, 1);
          var le         = $(label.element);
          le.css({"margin-left":e.pageX - clickX,"margin-top" : e.pageY - clickY});
          le.find(".num").html(newValue);
        }
      }

      var stepMobile = function (line, label, e) {
        var pageX      = e.originalEvent.touches[0].pageX;
        var pageY      = e.originalEvent.touches[0].pageY;
        var min_pixels = line.axis.toPixels(line.axis.min);
        var max_pixels = line.axis.toPixels(line.axis.max);
        var actual_pos = line.axis.toPixels(line.options.value) + (pageY - clickY);
        if(min_pixels >= actual_pos && // min y max de eje Y
            max_pixels <= actual_pos ){

          line.svgElem.translate(pageX - clickX, pageY - clickY);
          var diffPixels = pageY - clickY;
          var pixels     = line.axis.toPixels(line.options.value);
          var newValue   = line.axis.toValue(pixels + diffPixels);
          newValue       = _.round(newValue, 1);
          var le = $(label.element);
          le.css({"margin-left":pageX - clickX,"margin-top" : pageY - clickY});
          le.find(".num").html(newValue);

        }
      }


      var stop = function (line, label, e) {
        var mchart = line.axis.chart.userOptions.getMChart();
        var chart = line.axis.chart;
        mchart.setTooltipEnabled(chart, true);

        var diffPixels          = e.pageY - clickY;
        var pixels              = line.axis.toPixels(line.options.value);
        var newPixels = pixels + diffPixels;
        var newValue            = line.axis.toValue(newPixels);
        if(newValue < line.axis.min){
          newValue = line.axis.min;
        }
        if(newValue > line.axis.max){
          newValue = line.axis.max;
        }
        newValue                = _.round(newValue, 1);
        var a                   = $("<div></div>>").append(line.options.label.text);
        a.find(".num").html(newValue);
        var newText             = a.html();
        line.options.value      = newValue;
        line.options.label.text = newText;

        line.svgElem.translate(0,0);
        var le = $(label.element);
        le.css({"margin-left":0,"margin-top" : 0});


        if(line.options.localEvents !== undefined &&
            line.options.localEvents.onStop !== undefined &&
            typeof line.options.localEvents.onStop == "function"){
          line.options.localEvents.onStop(newValue, e);
        }
        line.axis.update();
        $(document).unbind('.line');

        addDragLineEvents(chart);

      }



      var stopMobile = function (line, label, e) {
        // var pageX = e.originalEvent.touches[0].pageX;
        // var pageY = e.originalEvent.touches[0].pageY;
        var pageX  = e.changedTouches[e.changedTouches.length-1].pageX;
        var pageY  = e.changedTouches[e.changedTouches.length-1].pageY;
        var mchart = line.axis.chart.userOptions.getMChart();
        var chart  = line.axis.chart;
        mchart.setTooltipEnabled(chart, true);
        var diffPixels = pageY - clickY;
        var pixels     = line.axis.toPixels(line.options.value);


        var newPixels = pixels + diffPixels;
        var newValue            = line.axis.toValue(newPixels);
        if(newValue < line.axis.min){
          newValue = line.axis.min;
        }
        if(newValue > line.axis.max){
          newValue = line.axis.max;
        }
        newValue       = _.round(newValue, 1);


        var a          = $("<div></div>>").append(line.options.label.text);
        a.find(".num").html(newValue);
        var newText             = a.html();
        line.options.value      = newValue;
        line.options.label.text = newText;

        line.svgElem.translate(0,0);
        var le = $(label.element);
        le.css({"margin-left":0,"margin-top" : 0});



        if(line.options.localEvents !== undefined &&
            line.options.localEvents.onStop !== undefined &&
            typeof line.options.localEvents.onStop == "function"){
          line.options.localEvents.onStop(newValue, e);
        }

        line.axis.update();
        $(document).unbind('.line');

        addDragLineEvents(chart);
      }



      var execLoadFunctions = function(loadFunctions, event){
        var chart = event.target;
        _.each(loadFunctions, function(lf){
          lf(event);
        });

        addDragLineEvents(chart);
      }

      var addDragLineEvents = function(chart){
        _.each(chart.yAxis, function(y){
          _.each(y.plotLinesAndBands, function(lineElem){
             var line = lineElem.svgElem;
             var label = lineElem.label;
            if(lineElem.options.editable && lineElem.options.editableEnabled && lineElem.label){

             label.addClass("drag-control");

             line
                .addClass("draggable")
                .translate(0, 0);

             label.on('touchstart', function(e){
              startDragging(lineElem, label, e);
              e.preventDefault();
            });

             label.on('mousedown', function(e){
              startDragging(lineElem, label, e)
            });

           }else{
             label.removeClass("drag-control");
             line.removeClass("draggable");
             $(label).off('touchstart');
             $(label).off('mousedown');
           }
          });
        });
      }


      function convertHex(hex,opacity){
        var hexFormated = hex.replace('#','');
        var r = parseInt(hexFormated.substring(0,2), 16);
        var g = parseInt(hexFormated.substring(2,4), 16);
        var b = parseInt(hexFormated.substring(4,6), 16);

        var result = 'rgba('+r+','+g+','+b+','+opacity/100+')';
        return result;
      }

      function ArrayHasData (arr) {
        var hasData = false;
        if(arr !== undefined && arr.length > 0){
          angular.forEach(arr, function(item) {
            if(typeof item === 'object'){
              if(item[1] !== null && !isNaN(item[1])){
                hasData = true;
              }
            } else if(item !== null && !isNaN(item)){
              hasData = true;
            }
          });
        }
        return hasData;
      }

      function togglePlotVisible(plot) {
        if (plot.options.isVisible === undefined){
          plot.options.isVisible = true;
        }
        if (plot.options.isVisible) {
          hidePlot(plot);
        } else {
          showPlot(plot);
        }
      }

      function hidePlot(plot) {
        plot.label.attr({
          opacity: 0
        });
        plot.svgElem.attr({
          opacity: 0
        });
        plot.options.isVisible = false;
      }

      function showPlot(plot) {
        plot.label.attr({
          opacity: 1
        });
        plot.svgElem.attr({
          opacity: 1
        });
        plot.options.isVisible = true;
      }

      function resizeChartFromValues (chart) {
        var pixelsForValue = 30;
        var paddingValue   = 15;
        var constantHeight = 120;
        var minHeight      = 300;
        var axis           = chart.xAxis;
        var width          = 0;
        for (var i = 0; i < axis.series.length; i++) {
          var serie = axis.series[i];
          if (serie.userOptions.pointWidth === undefined) {
            width += pixelsForValue;
          } else {
            width += serie.userOptions.pointWidth + paddingValue;
          }
        }
        var h = 0;
        if (axis.series) {
          h = (axis.categories.length * width) + constantHeight;
          h = h < minHeight ? minHeight : h;
          //chart.update({chart : {height : h}});
        }
        return h;
      }

      function getHeightFromConfig(config) {
        var pixelsForValue = 30; //pixeles para los valores
        var paddingValue   = 15; //si esta definido el pointWidth, se agrega el padding
        var constantHeight = 150;
        var minHeight      = 300;
        var axis           = config.xAxis;
        var series         = config.series;
        var width          = 0;
        var h              = 0;

        for (var i = 0; i < series.length; i++) {
          var serie = series[i];
          if (["line", "spline", "errorbar"].indexOf(serie.type) === -1) {
            if (serie.pointWidth === undefined) {
              width += pixelsForValue;
            } else {
              width += serie.pointWidth + paddingValue;
            }
          }
        }

        if (series && axis.categories !== undefined) {
          h = (axis.categories.length * width) + constantHeight;
        }
        h = h < minHeight ? minHeight : h;

        return h;
      }





    function MultiChart(text, options) {

      this.HcConfig      = angular.copy(Config.multiChart);
      this.loadFunctions = [];
      var lf             = this.loadFunctions;
      var that           = this;

      this.HcConfig.chart.events.load = function(e){
        execLoadFunctions(lf, e);
        var chart = e.target;
        if(chart !== undefined){
          Highcharts.addEvent(window, 'beforeprint', function () {
            chart._screenMediaWidth = chart.chartWidth;
            chart.setSize(chart.options.chart.printWidth, chart.chartHeight, false);
          });
          Highcharts.addEvent(window, 'afterprint', function () {
            chart.setSize(null, chart.chartHeight, false);
          });

        }

      }

      this.HcConfig.chart.events.redraw = function(e){
        var chart = e.target;
        addDragLineEvents(chart);
      }

      this.HcConfig.getMChart = function(){
        return that;
      };

      angular.forEach(this.HcConfig.yAxis, function(axis){
        delete axis.id;
      });
      this.HcConfig.test         = [1, 2, 3, 4, 5];
      this.HcConfig.showTime     = false;
      this.HcConfig.title.text   = text;
      this.HcConfig.horizontal   = false;
      this.HcConfig.title.margin = 0;
      this.ejes                  = this.HcConfig.yAxis; //se mantienen desde el config original
      this.primerEje             = null;

      this.tooltipFormatter = this.HcConfig.tooltip.formatter;


      //vacia las series
      this.HcConfig.series.splice(0, this.HcConfig.series.length);

      //vacia plotBands
      this.HcConfig.xAxis.plotBands.splice(0, this.HcConfig.xAxis.plotBands.length);
      //Variables de referencia
      this.plotBands = this.HcConfig.xAxis.plotBands;
      this.plotLines = this.HcConfig.xAxis.plotLines;

      /*
      //Agrega linea en el dia actual
      this.plotLines.push({
              color:'rgb(255,0,0)',
              width: 1,
              value:moment().unix()*1000,
            });
      */

      this.estadosFenologia = [];
      this.comentariosRect  = [];
      this.hadLines         = false;

      this.serieComentarios = angular.copy(serieSampleComentario);
      if(options !== undefined ){
        if (options.type === "pie") {
          this.HcConfig.tooltip.formatter = null;
          this.HcConfig.tooltip.positioner = null;
          this.options = options;
        }
        if(options.userOptions !== undefined){
          angular.merge(this.HcConfig, options.userOptions);
        }
      }
    }

    function addRect(chart, mc, estados, inicio, fin, clase){
      clase = clase || 'rect';
      var xAxis = chart.xAxis[0];
      var yAxis = chart.yAxis[mc.primerEje]
      var heightEstados = 20;
      mc.HcConfig.xAxis.offset = heightEstados;

      //Rectangulo contenedor

      chart.renderer.rect(chart.plotLeft, chart.plotBox.y + chart.plotBox.height, chart.plotWidth, heightEstados)
      .attr({
        'stroke-width': 0.5,
        stroke: 'rgba(0, 0, 0, 0.6)',
        fill: 'transparent',
        zIndex: 1
      }).addClass(clase).add();
      var xmin = chart.plotLeft;
      var xmax = chart.plotLeft + chart.plotWidth;

      //Rectangulos de cada estado
      angular.forEach(estados, function(estado) {
        if (estado.to == 0) {
          estado.sinFin = true;
          estado.to = moment().unix() * 1000;
        }
        if (xAxis.toPixels(estado.to) > xmin && xAxis.toPixels(estado.from) < xmax) {

          var leftLimit = xAxis.toPixels(estado.from),
          widthEstado = xAxis.toPixels(estado.to) - xAxis.toPixels(estado.from);
          // Cambia el rango de fechas para dibujar si la fecha sobrepasa los limites del grafico
          if(leftLimit < xmin){
            leftLimit = xmin;
            widthEstado = xAxis.toPixels(estado.to) - leftLimit;
          }

          if (widthEstado > xmax - leftLimit) {
            widthEstado = xmax - leftLimit;
          }

          chart.renderer.rect(leftLimit,chart.plotBox.y + chart.plotBox.height, widthEstado, heightEstados)
          .attr({
            'stroke-width': 1,
            stroke: estado.borderColor,
            fill: estado.color,
            zIndex: 2
          }).addClass(clase)
          .on("mouseout", function(e){
            estado.visibleTooltip = false;
            if (estado.events.mouseout !== undefined) {
              estado.events.mouseout(e);
            }
            $(".tooltipEstado").css({
              display: "none"
            });
          })
          .on("mousemove", function(e){
            if (estado.visibleTooltip == false && estado.showDetail == false) {
              estado.visibleTooltip = true;
            }
            var a  = this.getBBox();
            $(".tooltipEstado").css({
              left: e.layerX - ($(".tooltipEstado").width()/2) - 10,
              top: a.y + heightEstados + 15,
              display: estado.visibleTooltip ? "inline-block" : "none"
            }).html(estado.label.text)
            if (estado.events.mousemove!== undefined) {
              estado.events.mousemove(e);
            }
          })
          .on('click', function(e) {
            estado.visibleTooltip = !estado.visibleTooltip;
            $(".tooltipEstado").css({
              display: estado.visibleTooltip ? "inline-block" : "none"
            });
            if (estado.events.click !== undefined) {
              estado.events.click(e);
            }
          })
          .add();
        }
      });
    }

    MultiChart.prototype = {

      copiarConfiguracion : function() {
        this.HcConfig = angular.copy(Config.multiChart);
      },
      getConfig: function () {
        return this.HcConfig;
      },

      addLoadFunction : function(lf){
        this.loadFunctions.push(lf);
      },


      setTooltipEnabled : function(chart, e){
        var e = e !== undefined ? e : true;
        chart.update({
          tooltip: {
            enabled: e
          }
        });
      },





      sensorEditable : function(editable, editableEnabled){
        var chart = this.HcConfig.getChartObj();
        if(editableEnabled == undefined){
          var editableEnabled = editable;
        }
        _.each(chart.yAxis, function(y){
          _.each(y.plotLinesAndBands, function(lineElem){
            lineElem.options.editable = editable;
            lineElem.options.editableEnabled = editableEnabled;
          });
        });
        chart.redraw();
      },



      toResumen: function(options) {
        var c = this.HcConfig;
        this.deletePositioner();

        c.chart.backgroundColor = null;

        c.chart.marginTop    = 40;
        c.chart.marginRight  = 5;
        c.chart.marginbottom = 45;
        c.chart.marginLeft   = 5;

        c.chart.spacingTop    = 0;
        c.chart.spacingRight  = 0;
        c.chart.spacingBottom = 0;
        c.chart.spacingLeft   = 0;

        c.legend.borderWidth = 0;
        c.legend.padding     = 2;
        c.title.align        = 'left';
        c.title.x            = 16;
        c.title.y            = 25;
        c.title.style        = {
          whiteSpace   : 'nowrap',
          textOverflow : 'ellipsis',
          color        : '#616161'
        };

        c.xAxis.alternateGridColor = "#f5f5f5";
        c.xAxis.tickInterval = 24 * 3600 * 1000;
        c.xAxis.dateTimeLabelFormats = {
          day: '%e %b',
        }

        if(options){
          if(options.legend == false){
            c.legend.enabled = false;
          }
        }
        c.plotOptions.column= {
          maxPointWidth : 40
        }

        // c.legend.enabled        = false;
         c.chart.zoomType        = null;

        // c.tooltip.crosshair     = false;
        // c.tooltip.shared        = false;
        // c.tooltip.formatter     = null;
        // c.tooltip.positioner    = null;

        c.exporting.enabled          = false;
        // c.xAxis.labels.lineWidth     = 0;
        // c.xAxis.labels.tickLength    = 0;
        // c.xAxis.labels.y             = 15;

        // angular.forEach(c.yAxis, function(ya) {
        //   ya.visible = false;
        //   ya.gridLineColor = "transparent";
        // });

        angular.forEach(c.yAxis, function(ya) {
          ya.title.text = "";
          ya.labels.align = "left";
          ya.labels.x = 0;
          ya.labels.y = 0;
        });


      },





      toMini : function() {
        var c                           = this.HcConfig;
        c.isMini                        = true;
        c.title.text                    = null;
        c.chart.backgroundColor = null;
        c.chart.margin          = [5, 5, 20, 5];

        c.chart.spacingTop      = 0;
        c.chart.spacingBottom   = 0;
        c.chart.spacingLeft     = 0;
        c.chart.spacingRight    = 0;

        c.legend.enabled        = false;
        c.chart.zoomType        = null;

        c.tooltip.crosshair     = false;
        c.tooltip.shared        = false;
        c.tooltip.formatter     = null;
        c.tooltip.positioner    = null;

        c.exporting.enabled     = false;
        c.xAxis.labels.lineWidth     = 0;
        c.xAxis.labels.tickLength    = 0;
        c.xAxis.labels.y             = 15;

        angular.forEach(c.yAxis, function(ya) {
          ya.visible = false;
          ya.gridLineColor = "transparent";
        });

        if (this.options !== undefined && this.options.type == "pie") {
          c.chart.margin = [0, 0, 0, 0];
          c.tooltip.enabled = true;
          angular.forEach(c.series, function(serie) {
            if (serie.type == "pie") {
              serie.dataLabels.enabled = false;
              serie.center = ["50%", "120%"];
              serie.size = "200%";
            }
          })
        }

      },
      setEjeX: function (eje, override) {
        if(override){
          this.HcConfig.xAxis = eje;
        }else{
          this.HcConfig.xAxis.categories = eje;
        }
      },
      setSideYAxis:function(position, oposite){//left o right
        if(this.HcConfig.yAxis[position] === undefined){
          return null;
        }
        this.HcConfig.yAxis[position].oposite = oposite;
      },
      showComparison : function() {
        this.HcConfig.showComparison = true;
      },
      setTitle : function (title) {
        this.HcConfig.title.text = title;
      },
      setSubtitle : function (subtitle) {
        this.HcConfig.subtitle.text =subtitle;
      },
      getTitle : function () {
        return this.HcConfig.title.text;
      },
      getHeight: function(){
        return getHeightFromConfig(this.HcConfig);
      },
      autoHeight: function(){
        var chart = this.HcConfig.getChartObj();
        return resizeChartFromValues(chart);
      },
      setHeight: function(h){
        var chart = this.HcConfig.getChartObj();
        chart.update({chart : {height : h}});
      },
      clearSeries: function () {
        this.HcConfig.series.splice(0, this.HcConfig.series.length);
        this.HcConfig.annotations.splice(0, this.HcConfig.annotations.length);
      },
      setSerie: function(serieId, data, redraw){
        var chart = this.HcConfig.getChartObj();
        var serie = chart.get(serieId);
        if(serie){
          serie.setData(data,redraw);
        }
      },
      xAxisRotation : function(num){
        this.HcConfig.xAxis.labels.rotation = num;
      },
      addContextButton : function(name, options) {
        this.HcConfig.exporting.buttons[name] = options;
      },
      deletePositioner : function() {
        delete this.HcConfig.tooltip.positioner;
      },
      deleteTooltipFormatter: function() {
        delete this.HcConfig.tooltip.formatter;
      },
      setPositioner : function(fn) {
        this.HcConfig.tooltip.positioner = fn;
      },
      showTimeTooltip : function(){
        this.HcConfig.showTime = true;
      },
      disableTooltip: function() {
        this.HcConfig.tooltip.enabled = false;
      },
      setTooltipFormatter : function(fn) {
        this.HcConfig.tooltip.formatter = fn;
      },
      setEvents : function(events) {
        this.HcConfig.chart.events = events;
      },
      setLabelFormatter : function(fn){
        this.HcConfig.xAxis.labels.formatter = fn;
      },

      setTableLabels : function () {
        //TEST probando con estilos para legends
        this.HcConfig.legend=  {
          layout: 'horizontal',
          align: 'left',
          verticalAlign: 'bottom',
          backgroundColor: '#f3f3f3',
          //borderWidth: 0,
          useHTML: true,
          //itemMarginBottom: 10,
          labelFormatter: function () {
            return '<div style="width:200px;">'+
              '<span>' + this.name + '</span>'+
              '</div>';
          },
        };

      },
      setStock: function(withStock){
        if(withStock === undefined){
          withStock = true;
        }

        this.HcConfig.navigator.enabled = withStock;

        if (withStock) {
          this.HcConfig.chartType = "stock";
        }else{
          if(this.HcConfig.chartType !== undefined){
          delete this.HcConfig.chartType;
          }
        }
      },
      setVar : function(nameVar, titles, value){
        angular.forEach(this.HcConfig.series, function(serie){
          if (titles.indexOf(serie.name) > -1) {
            serie[nameVar] = angular.copy(value);
          }
        });
      },
      setHorizontal: function(e){
        var enabled = e !== undefined ? e : true;
        this.HcConfig.chart.type = enabled ? "bar" : "column";
        this.HcConfig.horizontal = enabled;
      },

      getVar : function(nameVar,title){
        var r = null;
        angular.forEach(this.HcConfig.series, function(serie){
          if (serie.name == title) {
            r = angular.copy(serie[nameVar]);
          }
        });
        return r;
      },

      /* {
       *    color
       *    titulo
       *    medida
       *  }
       * */
      agregarEjeY : function (ejeData) {
        var eje = angular.copy(ejeSample);

        if (angular.isDefined(ejeData.color)) {
          eje.gridLineColor       = ejeData.color;
          eje.title.style.color   = ejeData.color;
          eje.labels.style.color  = ejeData.color;
        }
        if (angular.isDefined(ejeData.titulo)) {
          eje.title.text = ejeData.titulo;
        }
        if (angular.isDefined(ejeData.medida)) {
          eje.labels.format = "{value} "+ejeData.medida;
        }

        this.ejes.push(eje);

        //retorna posicion del ultimo eje agregado
        //es el indice del eje
        return this.ejes.length - 1;
      },

      /*
       * {
       *    name
       *    type : default spline
       *    lineWidth : default null
       *    yAxis : default autoincrement
       *    data : []
       *    suffix : null
       *    preffix : nulll
       *    markerSymbol : null
       *  }
       *
       *  funcion que maneja datos por defecto
       *
      */
      limpiarComentarios : function(){
        var index = this.HcConfig.series.indexOf(this.serieComentarios);
        if (index>-1) {
          this.HcConfig.series[index].data.splice(0,this.HcConfig.series[index].data.length);
        }
        //this.plotBands.splice(0, this.plotBands.length);
        //this.plotLines.splice(0, this.plotLines.length);
        this.comentariosRect.splice(0, this.comentariosRect.length);
      },

      agregarComentarios : function(arrComentarios,vm){
        var comentarioTemp ="";
        var serieComentarios = this.serieComentarios;
        //var arrayFinal=[];
        if (arrComentarios.length > 0) {
          this.HcConfig.xAxis.labels.y = 35;
        }
        angular.forEach(arrComentarios, function(comentario){
          comentarioTemp = {
            x      : comentario[0],
            isFlag : true,
            text   : comentario[2],
            id     : comentario[3],
            shape  : "url("+urls.SELF+"/assets/icons/msg.png)",
            title  : "",
            events : {
                click: function (e) {
                  $timeout(function(){
                    vm.mensajeSeleccionado = comentario;
                    vm.editarComentario();
                    vm.limpiarErrorEditar();
                  });
                },
              }
            },
          //arrayFinal.push(comentarioTemp);
          serieComentarios.data.push(comentarioTemp);
        });
        //serieComentarios.data=arrayFinal;
        if (this.HcConfig.series.indexOf(this.serieComentarios) == -1) {
          this.HcConfig.series.push(this.serieComentarios);
        }
        $timeout(function(){
          if(this.HcConfig!== undefined &&
              this.HcConfig.getConfig !== undefined){
            var c = this.HcConfig.getConfig();
            c.redraw();
          }
        },1000);
      },




      agregarSerie : function(serieNueva){
        if(!ArrayHasData(serieNueva.data) && (serieNueva.required === undefined || !serieNueva.required)){
          //si no tiene datos, retorna;
          return;
        }
        if(this.primerEje === null){
          this.primerEje = serieNueva.yAxis;
        }
        var serie = angular.copy(serieSample);

        if (angular.isDefined(serieNueva.oppositeAxis)) {
          this.HcConfig.yAxis[serieNueva.yAxis].opposite = serieNueva.oppositeAxis;
        }

        if (angular.isDefined(serieNueva.visibleAxis) && serieNueva.visibleAxis && !this.HcConfig.isMini) {
          this.HcConfig.yAxis[serieNueva.yAxis].visible = true;
          if(!this.hadLines || serieNueva.withLines){
            this.HcConfig.yAxis[serieNueva.yAxis].gridLineWidth = 1;
            this.HcConfig.yAxis[serieNueva.yAxis].gridLineColor = "#e0e0e0";
            this.hadLines = true;
          }

          if (angular.isDefined(serieNueva.softMin)){
            if(typeof  serieNueva.softMin == "boolean" && !serieNueva.softMin){
              delete this.HcConfig.yAxis[serieNueva.yAxis].softMin;
            }
            if(typeof  serieNueva.softMin == "number"){
              this.HcConfig.yAxis[serieNueva.yAxis].softMin= serieNueva.softMin;
            }
          }
          if (angular.isDefined(serieNueva.softMax)){
            if(typeof  serieNueva.softMax  == "boolean" && !serieNueva.softMax){
              delete this.HcConfig.yAxis[serieNueva.yAxis].softMax;
            }
            if(typeof  serieNueva.softMax  == "number"){
              this.HcConfig.yAxis[serieNueva.yAxis].softMax = serieNueva.softMax;
            }
          }
        }else{
          if (!this.HcConfig.isMini) {
            this.HcConfig.yAxis[serieNueva.yAxis].visible = false;
          }
        }

        if (angular.isDefined(serieNueva.datagrouping)) {
          serie.datagrouping= serieNueva.datagrouping;
        }

        if (angular.isDefined(serieNueva.tooltip)) {
          serie.tooltip = serieNueva.tooltip;
        }

        if (angular.isDefined(serieNueva.localData)) {
          serie.localData = serieNueva.localData;
        }


        if (angular.isDefined(serieNueva.showInLegend)) {
          serie.showInLegend = serieNueva.showInLegend;
        }
        if (angular.isDefined(serieNueva.legend)) {
          serie.showInLegend = serieNueva.legend;
        }
        if (angular.isDefined(serieNueva.tag)) {
          serie.tag= serieNueva.tag;
        }
        if (angular.isDefined(serieNueva.name)) {
          serie.name = serieNueva.name;
        }

        if (angular.isDefined(serieNueva.zones)) {
          serie.zones = serieNueva.zones;
        }

        if (angular.isDefined(serieNueva.className)) {
          serie.className = serieNueva.className;
        }

        if (angular.isDefined(serieNueva.visible)) {
          serie.visible = serieNueva.visible;
        }

        if (angular.isDefined(serieNueva.marker) || !serieNueva.marker) {
          if(angular.isUndefined(serie.marker)){
            serie.marker = {};
          }
          serie.marker.enabled = false;
        }

        if (angular.isDefined(serieNueva.type)) {
          serie.type = serieNueva.type;
          if (serieNueva.type == 'column'){
            serie.borderWidth = 1;
          }
          if (serieNueva.type == 'column' && angular.isDefined(serieNueva.width)){
            serie.pointWidth = serieNueva.width;
          }

          if (serieNueva.type == "area" && serieNueva.step !== undefined) {
            serie.step = serieNueva.step;
          }

          if (serieNueva.type == "pie") {
            var p = serieNueva.preffix || '';
            var s = serieNueva.suffix || '';
            serie.center = ["50%", "110%"];
            serie.size = "140%";
            serie.showInLegend = true;
            serie.slideOffset = 0;
            serie.dataLabels = {
              enabled: true,
              distance: -30,
              padding: 0,
              format : '<span>'+p+'{point.y:.1f}'+s+'</span>',
              _style: {
                fontWeight: 'bold',
                color: 'white'
              }
            };
            serie.startAngle = -90;
            serie.endAngle = 90;
          }
        }

        if (angular.isDefined(serieNueva.lineWidth)) {
          serie.lineWidth = serieNueva.lineWidth;
        }



       if (angular.isDefined(serieNueva.color)) {
         if (_.isObject(serieNueva.color)) {
          serie.color = serieNueva.color;
         }else{
           if (angular.isDefined(serieNueva.opacity)) {
             serie.color = convertHex(serieNueva.color, serieNueva.opacity);
           }else{
              serie.color = serieNueva.color;
           }
          if ((serie.lineWidth === 0 && serie.type == "spline") || serie.type == "arearange"){
            serie.marker.fillColor = serieNueva.color;
            serie.marker.lineColor = serieNueva.color;
          }

          if (serie.lineWidth === 0 && serie.type == "line") {
            serie.lineColor = "transparent";
          }

         }
        }


          //para borde del marker
        if(angular.isDefined(serieNueva.stroke)){
          serie.marker.lineWidth = serieNueva.stroke;
          if(angular.isDefined(serieNueva.strokeColor)){
            serie.marker.lineColor =  serieNueva.strokeColor;
          }
        }


        if (angular.isDefined( serieNueva.events)){
          serie.events = serieNueva.events;
        }

        if (angular.isDefined( serieNueva.radius)){
            serie.marker.enabled = true;
            serie.marker.radius = serieNueva.radius;
            serie.marker.width = serieNueva.radius*2 +1;
            serie.marker.height = serieNueva.radius*2 +1;
        }

        if (angular.isDefined(serieNueva.yAxis)) {
          serie.yAxis = serieNueva.yAxis;
          if(serieNueva.yAxis == 1 && !this.HcConfig.isMini){ // bares
            this.HcConfig.yAxis[serieNueva.yAxis].visible = true;
          }

            if (angular.isDefined(serieNueva.limite) && serieNueva.limite.cant !== null && serieNueva.limite.cant > 0) {
              if (angular.isDefined(serieNueva.limite.cant)) {
                this.addPlotLineY({
                  value     : serieNueva.limite.cant,
                  title     : serieNueva.limite.name,
                  color     : serieNueva.limite.color,
                  yAxis     : serieNueva.yAxis,
                  dashStyle : "DashDot"
                });
                this.HcConfig.yAxis[serieNueva.yAxis].max = serieNueva.limite.max || 20;
              }
            }

        }



        if (angular.isDefined(serieNueva.data) && serieNueva.data.length > 0) {
          if(serieNueva.data[0][0] !== undefined && _.isNumber(serieNueva.data[0][0])){
            serie.data = serieNueva.data;
          }else{
            //agregar serie en ejeX
            var dataFormateado = [];
            var dataEje = [];
            angular.forEach(serieNueva.data, function(dato, index){
              dataEje.push(dato[0]);
              dataFormateado.push(dato[1]);
            });
            if(angular.isUndefined(this.HcConfig.xAxis.categories)){
              this.HcConfig.xAxis.categories = dataEje;
              //delete this.HcConfig.xAxis.dateTimeLabelFormats;
              //delete this.HcConfig.tooltip.formatter;
            }
            serie.data = dataFormateado;
          }
        }else{
          serie.data = [];
        }

        //datos ya formateados
        if (angular.isDefined(serieNueva.dataF)) {
          serie.data = serieNueva.dataF;
        }

        if (angular.isDefined(serieNueva.labelsData) && serieNueva.labelsData !== null && this.HcConfig.xAxis.categories) { //agregar labels personalizados

          //serie.dataLabels = {};
          var ejeX         = this.HcConfig.xAxis.categories;

          serie.dataLabels = {
            useHTML: true,
            enabled: true,
            //allowOverlap: true,
            padding: serieNueva.labelsPadding || 0,
            style     : {color:"black"},
            align     : serieNueva.alignLabels || "top",
            position  : serieNueva.positionLabel|| "top",
            formatter : function (a) {
              var label = serieNueva.labelsData[ejeX.indexOf(this.x)];
              var c = "black";
              if(serieNueva.labelsColor !== undefined){
                if(serieNueva.labelsColor[ejeX.indexOf(this.x)] !== undefined){
                  c = serieNueva.labelsColor[ejeX.indexOf(this.x)];
                }
                if(typeof serieNueva.labelsColor == "string"){
                  c = serieNueva.labelsColor;
                }
              }
              if(angular.isNumber(label) || angular.isString(label)){
                return "<span class='data-labels' style='color:"+c+"'>" +
                    //(serieNueva.preffix || '') +
                    label+
                    //(serieNueva.suffix || '') +
                    "</span>";
              }
              else{
                return null;
              }
            },
          };//dataLabels






          /*


          var labels = {
            labelOptions : {
              shape   : 'connector',
              align   : 'right',
              justify : false,
              crop    : true,
              style   : {
                fontSize    : '0.8em',
                textOutline : '1px white'
              },
            },
            labels:[]
          }

          var hc = this.HcConfig;
          _.forEach(serieNueva.labelsData, function(ld, index){
            if(ld ){

              var pos = hc.xAxis.categories.indexOf(serieNueva.data[index][0]);
              console.log(pos);

              labels.labels.push({
                point : {
                  xAxis : 0,
                  yAxis : serieNueva.yAxis,
                  x     : pos, // serieNueva.data[index][0],
                  y     : serieNueva.data[index][1],
                },
                text : ld+""
              })
            }
          });

          this.HcConfig.annotations.push(labels);
          */









        }

        if (angular.isDefined(serieNueva.dataLabels)) {
          serie.dataLabels = serieNueva.dataLabels;
        }
        if (angular.isDefined(serieNueva.withLabels) && serieNueva.withLabels) {
          serie.dataLabels = {
            useHTML: true,
            enabled:true,
            style: {color: "black"}
          }
        }

        if (angular.isDefined(serieNueva.suffix)) {
          serie.tooltip.valueSuffix = serieNueva.suffix;
        }
        if (angular.isDefined(serieNueva.preffix)) {
          serie.tooltip.valuePreffix = serieNueva.preffix;
        }
        if (angular.isDefined(serieNueva.markerSymbol)) {
          serie.marker.symbol= serieNueva.markerSymbol;
        }
        if (angular.isDefined(serieNueva.enableMouseTracking)) {
          serie.enableMouseTracking = serieNueva.enableMouseTracking;
        }


        if (angular.isDefined(serieNueva.id)) {
          serie.id= serieNueva.id;
        }else{
          serie.id = serieNueva.name.replace(' ', '').toLowerCase();
        }
        if (angular.isDefined(serieNueva.linkedTo)) {
          serie.linkedTo = serieNueva.linkedTo;
        }


        if (angular.isDefined(serieNueva.pointFormatter)) {
          if(angular.isUndefined(serie.tooltip)){
            serie.tooltip = {};
          }
          serie.tooltip.enabled = true;
          serie.tooltip.pointFormatter = serieNueva.pointFormatter;
        }

        if (angular.isDefined(serieNueva.tooltip)) {
          serie.tooltip.enabled = serieNueva.tooltip;
        }

        this.HcConfig.series.push(serie);

        if (serieNueva.error !== undefined) {
          var serieError                  = angular.copy(serieErrorSample);
          serieError.data                 = serieNueva.error.dataError;
          serieError.tooltip.valueSuffix  = serieNueva.suffix;
          serieError.tooltip.valuePreffix = serieNueva.preffix;
          serieError.yAxis                = serieNueva.yAxis;
          serieError.color                = serieNueva.error.color;


          if (serieNueva.error.className !== undefined) {
            serieError.className = serieNueva.error.className ;
          }

          if (serieNueva.error.tooltip !== undefined) {
            serieError.tooltip.enabled = serieNueva.error.tooltip;
          }

          if (serieNueva.error.name === undefined) {
            serieError.name    = serieNueva.name;
          }else{
            serieError.name    = serieNueva.error.name;
          }
          if (serieNueva.error.nameMin === undefined) {
            serieError.nameMin    = serieError.name + " min";
          }else{
            serieError.nameMin    = serieNueva.error.nameMin;
          }

          if (serieNueva.error.nameMax === undefined) {
            serieError.nameMax    = serieError.name + " max";
          }else{
            serieError.nameMax    = serieNueva.error.nameMax;
          }

          this.HcConfig.series.push(serieError);
        }



        $rootScope.$broadcast('highchartsng.reflow');
      },

      toggleBands : function(tag){
        tag = tag || "default";
        var chart = this.HcConfig.getChartObj();
        if(chart === undefined){
          return false;
        }
        var i = chart.xAxis[0].plotLinesAndBands.length;
        _.forEach(chart.xAxis[0].plotLinesAndBands, function(plot){
          if(plot.options.tag === tag){
            togglePlotVisible(plot);
          }
        });
        _.forEach(chart.yAxis, function(serie){
          _.forEach(serie.plotLinesAndBands, function (plot) {
            if(plot.options.tag === tag){
              togglePlotVisible(plot);
            }
          });
        });
      },

      toggleSeriesByTag : function(tag, visible, redraw){
        var tag    = tag || "default";
        var redraw = redraw !== undefined ? redraw : true;
        var chart  = this.HcConfig.getChartObj();
        _.each(chart.series, function(s){
          if(s.options.tag === tag){
            //s.setVisible(visible, false);
            s.update({
              showInLegend : visible,
              visible: visible
            }, false);
          }
        });
        if(redraw){
          chart.redraw();
        }
      },




      toggleVisibleSeriesByTag : function(tag, visible, redraw){
        var tag    = tag || "default";
        var redraw = redraw !== undefined ? redraw : true;
        var chart  = this.HcConfig.getChartObj();
        _.each(chart.series, function(s){
          if(s.options.tag === tag){
            var visible = visible || !s.visible;
            s.update({
              visible: visible,
              showInLegend: true
            }, false);
          }
        });
        if(redraw){
          chart.redraw();
        }
      },


      hideAllSeries: function(op){
        var redraw = op.redraw !== undefined ? op.redraw : true;
        var chart  = this.HcConfig.getChartObj();
        var d = {
          visible: false
        }
        if(op.hideLegend){
          d.showInLegend = false
        }
        _.each(chart.series, function(s){
          s.update(d, false);
        });
        if(redraw){
          chart.redraw();
        }
      },



      redraw : function(){
        var chart = this.HcConfig.getChartObj();
        chart.redraw();
      },
      addPlotBandY: function(plotNueva) {
        var plot         = angular.copy(plotBandY);
        var op           = plotNueva.opacity || 20;
        plot.to          = plotNueva.to;
        plot.label.text  = plotNueva.title;
        plot.label.align = plotNueva.align || "center";
        plot.label.x     = -10;
        plot.color       = convertHex(plotNueva.color, op);
        plot.borderColor = plotNueva.borde || convertHex(plotNueva.color, 60);
        plot.borderWidth = 1;
        plot.tag         = plotNueva.tag || "default";

        if(plotNueva.num !== undefined ){
          plot.to = plotNueva.num;
        }

        if(plotNueva.from !== undefined ) {
          plot.from = plotNueva.from;
        }

        if (angular.isUndefined(this.HcConfig.yAxis[plotNueva.yAxis].plotBands)) {
          this.HcConfig.yAxis[plotNueva.yAxis].plotBands = [];
        }

        this.HcConfig.yAxis[plotNueva.yAxis].plotBands.push(plot);
      },

      /*
       * color
       * borde: default black
       * titulo
       * desde
       * hasta

       */
       addPlotBand : function (plotNueva) {
         var plot = angular.copy(plotBandX);

         if (angular.isDefined(plotNueva.color)) {
           plot.color = convertHex(plotNueva.color, 50);
         }

         if (angular.isDefined(plotNueva.borde)) {
           plot.borderColor = plotNueva.borde;
         }

         if (angular.isDefined(plotNueva.titulo)) {
           plot.label.text = plotNueva.titulo;
         }

         if (angular.isDefined(plotNueva.desde)) {
           plot.from = plotNueva.desde;
         }

         if (angular.isDefined(plotNueva.hasta)) {
           plot.to = plotNueva.hasta;
         }

         plot.label.rotation = 90;
         plot.label.y = 16;
         plot.label.align = plotNueva.align || "center";
         plot.tag = plotNueva.tag || "default";
         plot.label.style = {
           color: plotNueva.borde
         };
       this.plotBands.push(plot);
     },


      addPlotLineY: function(plotNueva) {
        var plot         = angular.copy(plotLineY);
        var op           = plotNueva.opacity || 100;
        plot.value       = plotNueva.value;
        plot.label.text  = plotNueva.title;
        plot.color       = convertHex(plotNueva.color, op);
        plot.label.color = plot.color; //convertHex(plotNueva.color, op)
        plot.dashStyle   = plotNueva.dashStyle || "solid";
        plot.tag         = plotNueva.tag || "default";
        plot.width       = plotNueva.width || 2;
        plot.zIndex      = plotNueva.zIndex || 7;
        plot.editable    = plotNueva.editable;
        plot.localEvents = plotNueva.events;

        if(plotNueva.label !== undefined){
          plot.label = plotNueva.label;
        }

        if (angular.isUndefined(this.HcConfig.yAxis[plotNueva.yAxis].plotLines)) {
          this.HcConfig.yAxis[plotNueva.yAxis].plotLines = [];
          this.HcConfig.yAxis[plotNueva.yAxis].visible   = true;
        }

        this.HcConfig.yAxis[plotNueva.yAxis].plotLines.push(plot);

        if(plotNueva.editable){
          plot.label.text += " <span class='num editable-label'>"+plot.value+"</span>";
          plot.editableEnabled = false;
        }
      },




        agregarComentarioRango : function(plotComentarios,vm){
          var pb = this.plotBands;
          var comentariosRect = this.comentariosRect;
          if (plotComentarios.length > 0) {
            this.HcConfig.title.margin = 50;
          }
          angular.forEach(plotComentarios, function(plotNuevo){
            var plotComentarioTemp={
              from: plotNuevo[0],
              to: plotNuevo[1],
              id: plotNuevo[3],
              zIndex:5,
              isComentario: true,
              className:"plotComentario",
              color: "#4dd0e1",
              borderColor: "#0097a7",
              visibleTooltip: true,
              showDetail: false,
              label: {
                text: plotNuevo[2].substring(0, 7)+" ...",
              },
              events: {
                mouseout: function(e){
                  //plotComentarioTemp.showDetail = false;
                  //vm.mostrarTooltipPlotband = false;
                },
                click: function (e) {
                  $timeout(function(){
                    vm.mensajeSeleccionado = plotNuevo;
                    vm.plotFechas = moment(plotNuevo[0]).format("D MMM")+" - "+moment(plotNuevo[1]).format("D MMM: ");
                    vm.textoExtenso = plotNuevo[2];
                    vm.mostrarTooltipPlotband = !vm.mostrarTooltipPlotband;
                    plotComentarioTemp.showDetail = vm.mostrarTooltipPlotband;
                    vm.editarMenuComentario = false;
                  });
                },
                mousemove: function (e) {
                  $timeout(function(){
                    vm.plotFechas = moment(plotNuevo[0]).format("D MMM")+" - "+moment(plotNuevo[1]).format("D MMM: ");
                    vm.textoExtenso = plotNuevo[2];
                    console.log("--> "+
                    e.target.getClientRects()[0].top);
                    vm.tooltipPosition = {
                      x: e.pageX,
                      y: e.target.getClientRects()[0].top - 20
                    }
                  });
                },
              }
            };
            comentariosRect.push(plotComentarioTemp);
          });
        },



        addEventosRedraw : function(inicio,fin){
          var mc = this;
          mc.HcConfig.chart.events.redraw =  function(){
            $('.comment-rect').remove();
            addRect(this, mc, mc.comentariosRect,inicio,fin, "comment-rect");
          };
          mc.HcConfig.chart.events.load = function(){
            $('.comment-rect').remove();
            addRect(this, mc, mc.comentariosRect,inicio,fin, "comment-rect");
          };
        }


    }; //end prototype

    return MultiChart;
    }]);
}());
